import { Box, Typography, Button } from "@carrotfertility/carotene-core"
import { useStateMachine } from "#/components/context/stateMachine/StateMachineV2"
import React, { ReactElement } from "react"
import { useIntl, FormattedMessage } from "react-intl"
import { useSelector } from "react-redux"
import { getCompanyDisplayName } from "#/redux/reducers/companyInfo"
import { getShortJourneyLabel } from "../hooks/useJourneyOptions"
import { CaseRateRenewalModalButtonGroup } from "./CaseRateRenewalModalButtonGroup"
import { CaseRateRenewalModalTopSection } from "./CaseRateRenewalModalTopSection"
import { OPTIONS } from "./steps/CarrotPlanOptionsStep"
import { RoutingFlowType } from "#/components/carrot-plans/types/routingFlowType"
import { useStartRouting } from "#/components/carrot-plans/shared/useQueryStartRouting"

type JourneyNotSupportedDialogProps = {
  memberJourney: string
}

export function JourneyNotSupportedDialog({ memberJourney }: JourneyNotSupportedDialogProps): ReactElement {
  const intl = useIntl()
  const { send } = useStateMachine()
  const { startRouting } = useStartRouting(RoutingFlowType.CASE_RATE_RENEWAL)
  const journeyLabel = getShortJourneyLabel(memberJourney)
  const companyName = useSelector(getCompanyDisplayName) ?? intl.formatMessage({ defaultMessage: "Your company" })
  const formattedMemberJourney = journeyLabel
    ? intl.formatMessage(journeyLabel)
    : intl.formatMessage({ defaultMessage: "your current journey" })

  return (
    <>
      <CaseRateRenewalModalTopSection header={intl.formatMessage({ defaultMessage: "Get a new Carrot Plan" })} />
      <Box>
        <Typography variant="body1" color={(theme) => theme.palette.text.secondary}>
          <FormattedMessage
            defaultMessage="{companyName} no longer offers support for {formattedMemberJourney}. Get a new Carrot Plan or let us know you no longer need support."
            values={{ companyName, formattedMemberJourney }}
          />
        </Typography>
        <Box display="flex" justifyContent="flex-end"></Box>
        <CaseRateRenewalModalButtonGroup
          buttonOne={
            <Button variant="text" color="secondary" onClick={() => send(OPTIONS.DONE_FOR_NOW)}>
              <FormattedMessage defaultMessage="I'm done using Carrot" />
            </Button>
          }
          buttonTwo={
            <Button variant="contained" onClick={() => startRouting()}>
              <FormattedMessage defaultMessage="Get new Carrot Plan" />
            </Button>
          }
        />
      </Box>
    </>
  )
}
